import React, { useState } from "react";
import { Box, Button } from "@mui/material";
import AuthLayout from "src/layouts/AuthLayout";
import { useNavigate } from "react-router";
import { useSnackbar } from "notistack";
import useAxiosPrivate from "src/hooks/useAxiosPrivate";
import { AUTH_API_URL } from "src/api/axios";
import DefaultImage from "../../assets/images/Default_image.png";
import { useEffect } from "react";
import useLogout from "src/hooks/useLogout";
import { PATH_AUTH, PATH_DASHBOARD } from "src/routes/paths";
import { useMutation, useQuery } from 'react-query';

const KycUpload = () => {


  const { enqueueSnackbar } = useSnackbar();
  const axiosPrivate = useAxiosPrivate();
  const logout = useLogout();
  const navigate = useNavigate();

  const [ownerIdFront, setOwnerIdFront] = useState("");
  const [ownerIdBack, setOwnerIdBack] = useState("");
  const [shopAddressFront, setShopAddressFront] = useState("");
  const [shopAddressBack, setShopAddressBack] = useState("");

  const [ownerIdFrontImageShow, setOwnerIdFrontImageShow] = useState("");
  const [ownerIdBackImageShow, setOwnerIdBackImageShow] = useState("");
  const [shopAddressFrontImageShow, setShopAddressFrontImageShow] = useState("");
  const [shopAddressBackImageShow, setsetShopAddressBackImageShow] = useState("");

  const [imageName, setImageName] = useState({});
  const { data: userData } = useQuery(
    "userData",
    async ({ signal }) => {
      return await axiosPrivate
        .get(AUTH_API_URL.getProfile)
        .then((res) =>
          res.data
        ).catch((err) => {
          console.log(err);
        });
    },
    { refetchOnWindowFocus: false }
  );
  const props = userData?.vendor;



  useEffect(() => {
    setImageName({ ...imageName, email: props?.businessEmail });
    setOwnerIdFrontImageShow(props?.owner_id_front_copy);
    setOwnerIdBackImageShow(props?.owner_id_back_copy);
    setShopAddressFrontImageShow(props?.shop_address_proof_front);
    setsetShopAddressBackImageShow(props?.shop_address_proof_back);
  }, [props]);
  /*   useEffect(() => {
      setImageName({ ...imageName, email: props?.userData?.businessEmail });
      setOwnerIdFrontImageShow(props?.userData?.owner_id_front_copy);
      setOwnerIdBackImageShow(props?.userData?.owner_id_back_copy);
      setShopAddressFrontImageShow(props?.userData?.shop_address_proof_front);
      setsetShopAddressBackImageShow(props?.userData?.shop_address_proof_back);
    }, [props.userData]); */

  const handleOwnerIdFrontImage = async (ev) => {
    if (ev.type.includes("image")) {
      let userImgSrc = URL.createObjectURL(ev);
      const formData = new FormData();
      formData.append("image", ev);
      setOwnerIdFront(userImgSrc);
      const imageData = await axiosPrivate.post(AUTH_API_URL.uploadImage, formData).catch((e) => {
        enqueueSnackbar(e?.response?.data?.message, {
          variant: "error",
          anchorOrigin: { vertical: "top", horizontal: "right" },
          autoHideDuration: 2000,
        });
      });
      setImageName({ ...imageName, owner_id_front_copy: imageData?.data?.file_name });
    } else {
      enqueueSnackbar("Please select only jpeg, jpg, png, webp file", {
        variant: "error",
        anchorOrigin: { vertical: "top", horizontal: "right" },
        autoHideDuration: 2000,
      });
    }
  };
  // const handleOwnerIdBackImage = async (ev) => {
  //   if (ev.type.includes("image")) {
  //     let userImgSrc = URL.createObjectURL(ev);
  //     const formData = new FormData();
  //     formData.append("image", ev);
  //     setOwnerIdBack(userImgSrc);
  //     const imageData = await axiosPrivate.post(AUTH_API_URL.uploadImage, formData).catch((e) => {
  //       enqueueSnackbar(e?.response?.data?.message, {
  //         variant: "error",
  //         anchorOrigin: { vertical: "top", horizontal: "right" },
  //         autoHideDuration: 2000,
  //       });
  //     });
  //     setImageName({ ...imageName, owner_id_back_copy: imageData?.data?.file_name });
  //   } else {
  //     enqueueSnackbar("Please select only jpeg, jpg, png, webp file", {
  //       variant: "error",
  //       anchorOrigin: { vertical: "top", horizontal: "right" },
  //       autoHideDuration: 2000,
  //     });
  //   }
  // };
  const handleShopAddressFrontImage = async (ev) => {
    if (ev.type.includes("image")) {
      let userImgSrc = URL.createObjectURL(ev);
      const formData = new FormData();
      formData.append("image", ev);
      setShopAddressFront(userImgSrc);
      const imageData = await axiosPrivate.post(AUTH_API_URL.uploadImage, formData).catch((e) => {
        enqueueSnackbar(e?.response?.data?.message, {
          variant: "error",
          anchorOrigin: { vertical: "top", horizontal: "right" },
          autoHideDuration: 2000,
        });
      });
      setImageName({ ...imageName, shop_address_proof_front: imageData?.data?.file_name });
    } else {
      enqueueSnackbar("Please select only jpeg, jpg, png, webp file", {
        variant: "error",
        anchorOrigin: { vertical: "top", horizontal: "right" },
        autoHideDuration: 2000,
      });
    }
  };
  // const handleShopAddressBackImage = async (ev) => {
  //   if (ev.type.includes("image")) {
  //     let userImgSrc = URL.createObjectURL(ev);
  //     const formData = new FormData();
  //     formData.append("image", ev);
  //     setShopAddressBack(userImgSrc);
  //     const imageData = await axiosPrivate.post(AUTH_API_URL.uploadImage, formData).catch((e) => {
  //       enqueueSnackbar(e?.response?.data?.message, {
  //         variant: "error",
  //         anchorOrigin: { vertical: "top", horizontal: "right" },
  //         autoHideDuration: 2000,
  //       });
  //     });
  //     setImageName({ ...imageName, shop_address_proof_back: imageData?.data?.file_name });
  //   } else {
  //     enqueueSnackbar("Please select only jpeg, jpg, png, webp file", {
  //       variant: "error",
  //       anchorOrigin: { vertical: "top", horizontal: "right" },
  //       autoHideDuration: 2000,
  //     });
  //   }
  // };

  const handleUploadImages = async () => {
    console.log(imageName);
    if (imageName.owner_id_front_copy === undefined || imageName.shop_address_proof_front === undefined) {
      if (props?.request_status === 0) {
        enqueueSnackbar("Please upload all kyc images again", {
          variant: "error",
          anchorOrigin: { vertical: "top", horizontal: "right" },
          autoHideDuration: 2000,
        });
      } else {
        enqueueSnackbar("Please upload all kyc images", {
          variant: "error",
          anchorOrigin: { vertical: "top", horizontal: "right" },
          autoHideDuration: 2000,
        });
      }
    } else {
      const image = await axiosPrivate.post(AUTH_API_URL.uploadKyc, imageName);
      if (image?.data?.message) {
        enqueueSnackbar(image?.data?.message, {
          variant: "success",
          anchorOrigin: { vertical: "top", horizontal: "right" },
          autoHideDuration: 2000,
        });
        localStorage.clear();
        await logout();
        navigate(PATH_AUTH.login);
      }
    }
  };

  const handleGoToLogin = async () => {
    localStorage.clear();
    await logout();
    navigate(PATH_AUTH.login);
  };
  return (
    <>
      <AuthLayout title="Complete Your KYC Detail">
        <Box className="vendor_kyc_container" sx={{maxWidth:"100% !important"}}>
          <div className="row g-4 w-100">
            <div className="col-md-6">
              <Box display="flex" flexDirection={"column"} alignItems="center">
                {
                  <Box sx={{ width: "100%", height: "140px", borderRadius: "12px", overflow: "hidden", boxShadow: "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px" }}>
                    <img
                      style={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: "center" }}
                      src={ownerIdFrontImageShow == null && ownerIdFront == "" ? DefaultImage : ownerIdFront == "" ? process.env.REACT_APP_PROFILE_URL + "vendorKYC/" + ownerIdFrontImageShow : ownerIdFront}
                      alt="profile"
                    />
                  </Box>
                }
                <Button fullWidth className="my-4 app_text_14_500 p-2 text-capitalize text-black app_bg_white" variant="text" component="label">
                  Upload Owner ID
                  <input
                    hidden
                    // accept="kycImage/*"
                    onChange={(event) => {
                      const files = event.target.files[0];
                      if (files !== undefined) {
                        handleOwnerIdFrontImage(files);
                      }
                    }}
                    type="file"
                  />
                </Button>
              </Box>
            </div>
            {/* <div className="col">
              <Box display="flex" flexDirection={"column"} alignItems="center">
                {
                  <Box sx={{ width: "140px", height: "140px", borderRadius: "12px", overflow: "hidden", boxShadow: "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px" }}>
                    <img
                      style={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: "center" }}
                      src={ownerIdBackImageShow == null && ownerIdBack == "" ? DefaultImage : ownerIdBack == "" ? process.env.REACT_APP_PROFILE_URL + "vendorKYC/" + ownerIdBackImageShow : ownerIdBack}
                      alt="profile"
                    />
                  </Box>
                }
                <Button fullWidth className="my-4 app_text_14_500 p-2 text-black text-capitalize app_bg_white" variant="text" component="label">
                  Upload Owner ID Back Copy
                  <input
                    hidden
                    accept="kycImage/*"
                    onChange={(event) => {
                      const files = event.target.files[0];
                      if (files !== undefined) {
                        handleOwnerIdBackImage(files);
                      }
                    }}
                    type="file"
                  />
                </Button>
              </Box>
            </div> */}
            <div className="col-md-6">
              <Box display="flex" flexDirection={"column"} alignItems="center">
                {
                  <Box sx={{ width: "100%", height: "140px", borderRadius: "12px", overflow: "hidden", boxShadow: "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px" }}>
                    <img
                      style={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: "center" }}
                      src={shopAddressFrontImageShow == null && shopAddressFront == "" ? DefaultImage : shopAddressFront == "" ? process.env.REACT_APP_PROFILE_URL + "vendorKYC/" + shopAddressFrontImageShow : shopAddressFront}
                      alt="profile"
                    />
                  </Box>
                }
                <Button fullWidth className="my-4 app_text_14_500 p-2 text-capitalize text-black app_bg_white" variant="text" component="label">
                  Upload Business Address 
                  <input
                    hidden
                    // accept="kycImage/*"
                    onChange={(event) => {
                      const files = event.target.files[0];
                      if (files !== undefined) {
                        handleShopAddressFrontImage(files);
                      }
                    }}
                    type="file"
                  />
                </Button>
              </Box>
            </div>
            {/* <div className="col">
              <Box display="flex" flexDirection={"column"} alignItems="center">
                {
                  <Box sx={{ width: "140px", height: "140px", borderRadius: "12px", overflow: "hidden", boxShadow: "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px" }}>
                    <img
                      style={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: "center" }}
                      src={shopAddressBackImageShow == null && shopAddressBack == "" ? DefaultImage : shopAddressBack == "" ? process.env.REACT_APP_PROFILE_URL + "vendorKYC/" + shopAddressBackImageShow : shopAddressBack}
                      alt="profile"
                    />
                  </Box>
                }
                <Button fullWidth className="my-4 app_text_14_500 p-2 text-capitalize text-black app_bg_white" variant="text" component="label">
                  Upload Shop Address Proof Back
                  <input
                    hidden
                    accept="kycImage/*"
                    onChange={(event) => {
                      const files = event.target.files[0];
                      if (files !== undefined) {
                        handleShopAddressBackImage(files);
                      }
                    }}
                    type="file"
                  />
                </Button>
              </Box>
            </div> */}
          </div>
          <Box sx={{ mt: 4, width: "100%" }}>
            {props?.kyc_upload_status === 0 ? (
              <div>
                {props?.request_status === 0 ? <h6 style={{ color: "red", margin: "1rem 0", textAlign: "center" }}>Your KYC Request Is Rejected. Please Again Upload Valid Details!! </h6> : ""}
                <Button fullWidth variant="contained" className="text-black app_text_16_semibold app_btn_lg app_btn_white_hover_bg app_btn_radius_24 app_bg_white" onClick={handleUploadImages}>
                  Submit
                </Button>
                &nbsp;
                <Button fullWidth variant="contained" className="text-black app_text_16_semibold app_btn_lg app_btn_white_hover_bg app_btn_radius_24 app_bg_white" onClick={handleGoToLogin}>
                  Logout
                </Button>
              </div>
            ) :
              (
                <Box display={"flex"} flexDirection="column">

                  <h6 style={{ color: "red", margin: "1rem 0", textAlign: "center" }}>
                    {
                      props?.request_status === 2 && props?.kyc_upload_status === 1 ? "Your KYC Request has been Approved! Please logout and And login Again!" :
                        'Your KYC Approve Request Still Pending. Please Wait For 1-2 Bussiness Days !!'
                    }
                  </h6>
                  <Button fullWidth variant="contained" className="text-black app_text_16_semibold app_btn_lg app_btn_white_hover_bg app_btn_radius_24 app_bg_white" onClick={handleGoToLogin}>
                    Logout
                  </Button>
                </Box>
              )}
          </Box>
        </Box>
      </AuthLayout>
    </>
  );
};

export default KycUpload;
